/**
 * Parses text with markdown highlights and returns text segments
 */
export const parseTextWithHighlights = (
  text: string,
): Array<{ text: string; isHighlight: boolean }> => {
  const highlightRegex = /\*\*(.*?)\*\*/g;
  const segments: Array<{ text: string; isHighlight: boolean }> = [];
  let lastIndex = 0;
  let match;

  while ((match = highlightRegex.exec(text)) !== null) {
    // Add text before highlight
    if (match.index > lastIndex) {
      segments.push({
        text: text.substring(lastIndex, match.index),
        isHighlight: false,
      });
    }
    // Add highlighted text
    segments.push({
      text: match[1],
      isHighlight: true,
    });
    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after last highlight
  if (lastIndex < text.length) {
    segments.push({
      text: text.substring(lastIndex),
      isHighlight: false,
    });
  }

  // If no highlights found, return the whole text as a single segment
  if (segments.length === 0) {
    segments.push({ text, isHighlight: false });
  }

  return segments;
};
